/**
 * JavaScript Graphical User Interface
 * Defining GUI.Utils namespace
 *
 * @author Eugene Lyulka
 * @version 2.0
 * @namespace GUI
 */
GUI.Utils = {};